module.exports = __webpack_public_path__ + "static/media/career-briefcase.96114456.svg";